import React from "react";
import { Spinner } from "react-bootstrap";

const ReportHistorySection = ({
  searchQuery,
  onSearch,
  isRefreshing,
  onRefresh,
  currentRecords,
  filteredReports,
  indexOfFirstRecord,
  activeDownloadIndex,
  onDownload,
  currentPage,
  totalPages,
  recordsPerPage,
  onPreviousPage,
  onNextPage,
}) => (
  <div className="mt-5">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h3 className="mb-0">Recent Reports</h3>
      <div className="d-flex gap-2">
        <input
          type="text"
          placeholder="Search by Campaign ID"
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          className="form-control form-control-sm"
        />
        <button
          onClick={onRefresh}
          className="btn btn-secondary btn-sm btn-refresh"
          disabled={isRefreshing}
        >
          {isRefreshing ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Refreshing...
            </>
          ) : (
            "Refresh"
          )}
        </button>
      </div>
    </div>

    <div className="table-responsive" style={{ maxHeight: "300px", overflowY: "auto" }}>
      <table className="table table-hover">
        <thead className="table-light">
          <tr>
            <th>Campaign ID</th>
            <th>Created By</th>
            <th>Created On</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((item, index) => (
            <tr key={index}>
              <td>{item.campaign_id}</td>
              <td>{item.created_by}</td>
              <td>{item.created_on}</td>
              <td>{item.status}</td>
              <td>
                {(item.status?.toLowerCase() === "completed" ||
                  item.status?.toLowerCase() === "success") && (
                  <button
                    onClick={() => onDownload(item, index + indexOfFirstRecord)}
                    className="btn btn-sm btn-primary"
                    disabled={activeDownloadIndex === index + indexOfFirstRecord}
                  >
                    {activeDownloadIndex === index + indexOfFirstRecord
                      ? "Downloading..."
                      : "Download"}
                  </button>
                )}
              </td>
            </tr>
          ))}

          {filteredReports.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center text-muted">
                No reports found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    {filteredReports.length > recordsPerPage && (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <button
          className="btn btn-outline-primary btn-sm btn-refresh"
          onClick={onPreviousPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </span>
        <button
          className="btn btn-outline-primary btn-sm btn-refresh"
          onClick={onNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    )}
  </div>
);

export default ReportHistorySection;
